import L from 'leaflet';
import { isEmpty } from 'lodash';
import { Bert } from 'meteor/themeteorchef:bert';
import { CAMOptions } from '../client/photo-utilities';

/**
 * Draws the CAM data layer on the leaflet map.
 *
 * @param {object} arg - The object argument.
 * @param {object} arg.leafletMap - The leaflet map object.
 * @param {?object} arg.CAMDataLayer - The geoJSON layer where CAM data will be painted.
 * @param {boolean} [arg.isUpdate=false] - Flag to determine if we are doing an update.
 * @returns {object} The leaflet layers where the CAM data is painted.
 */
const drawCAMDataPoints = ({ isUpdate = false, CAMData, CAMDataLayer, leafletMap }) => {
  let newCAMDataLayer = '';
  if (!isUpdate) {
    newCAMDataLayer = L.geoJSON(null, CAMOptions).addTo(leafletMap);
  } else {
    newCAMDataLayer = CAMDataLayer;
    newCAMDataLayer.clearLayers();
  }

  if (!isEmpty(CAMData)) {
    try {
      newCAMDataLayer.addData(CAMData);
    } catch (error) {
      Bert.alert(`CAM Data Corrupt ${error}`, 'danger');
    }
  }
  return newCAMDataLayer;
};
export default drawCAMDataPoints;
